import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const MiniCartDefaultProps = {
  ...ClassNameDefaultProps,
};

export const MiniCartPropTypes = {
  ...ClassNamePropTypes,
};
